import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '../../shareds/translate/translate.module';

@Component({
  selector: 'app-not-found',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './not-found.component.html',
})
export class NotFoundComponent {
  constructor(private router: Router) {}
  goHome() {
    this.router.navigate(['/']);
  }
}
